(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('AuditEventsController', AuditEventsController);

  /* ngInject */
  function AuditEventsController(auditEventService, sessionService) {

    const vm = this;
    vm.currentPage = 1;
    vm.totalCount = 10;
    vm.pageChangeHandler = pageChangeHandler;
    vm.auditEvents = getAuditEvents();

    function pageChangeHandler(pageNum) {
      auditEventService(sessionService.getAuthToken()).query({ page: pageNum }, function(response) {
        vm.auditEvents = response.audit_events;
        vm.totalCount = response.meta.total_count;
      });
    }

    function getAuditEvents() {
      auditEventService(sessionService.getAuthToken()).query({ page: vm.currentPage}, function(response) {
        vm.auditEvents = response.audit_events;
        vm.totalCount = response.meta.total_count;
      });
    }
  }
})();
